var _rect, _rect2, _rect3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinterLightGrayBgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 0.5,
    width: 9,
    height: 3.26667,
    rx: 0.5,
    fill: "white",
    stroke: "#D0D3E2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 2.63281,
    width: 15,
    height: 7.53333,
    rx: 1,
    fill: "#D0D3E2",
    stroke: "#D0D3E2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 7.9668,
    width: 9,
    height: 7.53333,
    rx: 1,
    fill: "white",
    stroke: "#D0D3E2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 4.80091C11 4.50636 11.0799 4.26758 11.1786 4.26758H13.3214C13.4201 4.26758 13.5 4.50636 13.5 4.80091C13.5 5.09546 13.4201 5.33424 13.3214 5.33424H11.1786C11.0799 5.33424 11 5.09546 11 4.80091Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinterLightGrayBgOutline);
export default __webpack_public_path__ + "static/media/printerLightGrayBgOutline.0451815ae0ccbac82ac4882c1caaf227.svg";
export { ForwardRef as ReactComponent };